import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

import { AdalService } from '../../service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['login.css']
})
export class LoginComponent implements OnInit, OnDestroy {
	private sub: Subscription;
	constructor(private router: Router, private adalService: AdalService) { }

	ngOnInit() {
		if (this.adalService.userInfo) {
			/**
             * Check is logged-in user is a member of Azure group
             */
			this.sub = this.grapthInit().subscribe(memberInfo => {
				// console.log(memberInfo);
				const member = memberInfo;
				const isExist = member.value.find(x => x.id === '48fc27a5-386f-4451-896d-e5023f5d8d3b');
				if (isExist) {
					this.router.navigate(['utility/dashboard']);
				} else {
					this.router.navigate(['not-allowed'], { queryParams: { param: 'notamember' } });
				}

			});
		} else if (!this.adalService.userInfo) {
			this.adalService.login();
		}
	}

	ngOnDestroy() {
		if (this.sub) {
			// this.sub.unsubscribe();
		}
	}

	public get isLoggedIn() {
		return this.adalService.isAuthenticated;
	}

	private grapthInit(): Observable<any> {
		return this.adalService.get(this.adalService.config.endpoints.graphApiUri, `${this.adalService.config.endpoints.graphApiUri}v1.0/me/memberOf`);
	}
}
